import { render } from "./FormInputNameField.vue?vue&type=template&id=01c758d4"
import script from "./FormInputNameField.vue?vue&type=script&lang=js"
export * from "./FormInputNameField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__